 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062018465_COVER from '@/components/text/9780062018465_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062018465_TITLEPAGE from '@/components/text/9780062018465_Titlepage'
 import TEXT9780062018465_CONTENTS from '@/components/text/9780062018465_Contents'
 import TEXT9780062018465_FRONT_1 from '@/components/text/9780062018465_Front_1'
 import TEXT9780062018465_FRONT_2 from '@/components/text/9780062018465_Front_2'
 import TEXT9780062018465_PART_1 from '@/components/text/9780062018465_Part_1'
 import TEXT9780062018465_CHAPTER_1 from '@/components/text/9780062018465_Chapter_1'
 import TEXT9780062018465_CHAPTER_2 from '@/components/text/9780062018465_Chapter_2'
 import TEXT9780062018465_PART_2 from '@/components/text/9780062018465_Part_2'
 import TEXT9780062018465_CHAPTER_3 from '@/components/text/9780062018465_Chapter_3'
 import TEXT9780062018465_CHAPTER_4 from '@/components/text/9780062018465_Chapter_4'
 import TEXT9780062018465_CHAPTER_5 from '@/components/text/9780062018465_Chapter_5'
 import TEXT9780062018465_CHAPTER_6 from '@/components/text/9780062018465_Chapter_6'
 import TEXT9780062018465_CHAPTER_7 from '@/components/text/9780062018465_Chapter_7'
 import TEXT9780062018465_CHAPTER_8 from '@/components/text/9780062018465_Chapter_8'
 import TEXT9780062018465_CHAPTER_9 from '@/components/text/9780062018465_Chapter_9'
 import TEXT9780062018465_PART_3 from '@/components/text/9780062018465_Part_3'
 import TEXT9780062018465_CHAPTER_10 from '@/components/text/9780062018465_Chapter_10'
 import TEXT9780062018465_CHAPTER_11 from '@/components/text/9780062018465_Chapter_11'
 import TEXT9780062018465_CHAPTER_12 from '@/components/text/9780062018465_Chapter_12'
 import TEXT9780062018465_CHAPTER_13 from '@/components/text/9780062018465_Chapter_13'
 import TEXT9780062018465_CHAPTER_14 from '@/components/text/9780062018465_Chapter_14'
 import TEXT9780062018465_CHAPTER_15 from '@/components/text/9780062018465_Chapter_15'
 import TEXT9780062018465_CHAPTER_16 from '@/components/text/9780062018465_Chapter_16'
 import TEXT9780062018465_CHAPTER_17 from '@/components/text/9780062018465_Chapter_17'
 import TEXT9780062018465_CHAPTER_18 from '@/components/text/9780062018465_Chapter_18'
 import TEXT9780062018465_CHAPTER_19 from '@/components/text/9780062018465_Chapter_19'
 import TEXT9780062018465_CHAPTER_20 from '@/components/text/9780062018465_Chapter_20'
 import TEXT9780062018465_PART_4 from '@/components/text/9780062018465_Part_4'
 import TEXT9780062018465_CHAPTER_21 from '@/components/text/9780062018465_Chapter_21'
 import TEXT9780062018465_CHAPTER_22 from '@/components/text/9780062018465_Chapter_22'
 import TEXT9780062018465_CHAPTER_23 from '@/components/text/9780062018465_Chapter_23'
 import TEXT9780062018465_CHAPTER_24 from '@/components/text/9780062018465_Chapter_24'
 import TEXT9780062018465_CHAPTER_25 from '@/components/text/9780062018465_Chapter_25'
 import TEXT9780062018465_CHAPTER_26 from '@/components/text/9780062018465_Chapter_26'
 import TEXT9780062018465_CHAPTER_27 from '@/components/text/9780062018465_Chapter_27'
 import TEXT9780062018465_CHAPTER_28 from '@/components/text/9780062018465_Chapter_28'
 import TEXT9780062018465_CHAPTER_29 from '@/components/text/9780062018465_Chapter_29'
 import TEXT9780062018465_CHAPTER_30 from '@/components/text/9780062018465_Chapter_30'
 import TEXT9780062018465_CHAPTER_31 from '@/components/text/9780062018465_Chapter_31'
 import TEXT9780062018465_CHAPTER_32 from '@/components/text/9780062018465_Chapter_32'
 import TEXT9780062018465_CHAPTER_33 from '@/components/text/9780062018465_Chapter_33'
 import TEXT9780062018465_PART_5 from '@/components/text/9780062018465_Part_5'
 import TEXT9780062018465_CHAPTER_34 from '@/components/text/9780062018465_Chapter_34'
 import TEXT9780062018465_CHAPTER_35 from '@/components/text/9780062018465_Chapter_35'
 import TEXT9780062018465_CHAPTER_36 from '@/components/text/9780062018465_Chapter_36'
 import TEXT9780062018465_CHAPTER_37 from '@/components/text/9780062018465_Chapter_37'
 import TEXT9780062018465_CHAPTER_38 from '@/components/text/9780062018465_Chapter_38'
 import TEXT9780062018465_PART_6 from '@/components/text/9780062018465_Part_6'
 import TEXT9780062018465_CHAPTER_39 from '@/components/text/9780062018465_Chapter_39'
 import TEXT9780062018465_CHAPTER_40 from '@/components/text/9780062018465_Chapter_40'
 import TEXT9780062018465_CHAPTER_41 from '@/components/text/9780062018465_Chapter_41'
 import TEXT9780062018465_CHAPTER_42 from '@/components/text/9780062018465_Chapter_42'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062018465_BACK_1 from '@/components/text/9780062018465_Back_1'
 import TEXT9780062018465_BACK_2 from '@/components/text/9780062018465_Back_2'
 import TEXT9780062018465_BACK_3 from '@/components/text/9780062018465_Back_3'
 import TEXT9780062018465_BACK_3A from '@/components/text/9780062018465_Back_3a'
 import TEXT9780062018465_INDEX from '@/components/text/9780062018465_Index'
 import TEXT9780062018465_INDEX_1 from '@/components/text/9780062018465_Index_1'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780062018465_REVIEW from '@/components/text/9780062018465_Review'
 import TEXT9780062018465_OTHER_WORKS from '@/components/text/9780062018465_Other_Works'
 import TEXT9780062018465_CREDITS from '@/components/text/9780062018465_Credits'
 import TEXT9780062018465_COPYRIGHT from '@/components/text/9780062018465_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
 import TEXT9780062018465_FOOTNOTE_1 from '@/components/text/9780062018465_Footnote_1'
 import TEXT9780062018465_FOOTNOTE_2 from '@/components/text/9780062018465_Footnote_2'
 import TEXT9780062018465_FOOTNOTE_3 from '@/components/text/9780062018465_Footnote_3'
 import TEXT9780062018465_FOOTNOTE_4 from '@/components/text/9780062018465_Footnote_4'
 import TEXT9780062018465_FOOTNOTE_5 from '@/components/text/9780062018465_Footnote_5'
 import TEXT9780062018465_FOOTNOTE_6 from '@/components/text/9780062018465_Footnote_6'
 import TEXT9780062018465_FOOTNOTE_7 from '@/components/text/9780062018465_Footnote_7'
 import TEXT9780062018465_FOOTNOTE_8 from '@/components/text/9780062018465_Footnote_8'
 import TEXT9780062018465_FOOTNOTE_9 from '@/components/text/9780062018465_Footnote_9'
 import TEXT9780062018465_FOOTNOTE_10 from '@/components/text/9780062018465_Footnote_10'
 import TEXT9780062018465_FOOTNOTE_11 from '@/components/text/9780062018465_Footnote_11'
 import TEXT9780062018465_FOOTNOTE_12 from '@/components/text/9780062018465_Footnote_12'
 import TEXT9780062018465_FOOTNOTE_13 from '@/components/text/9780062018465_Footnote_13'
 import TEXT9780062018465_FOOTNOTE_14 from '@/components/text/9780062018465_Footnote_14'
 import TEXT9780062018465_FOOTNOTE_15 from '@/components/text/9780062018465_Footnote_15'
 import TEXT9780062018465_FOOTNOTE_16 from '@/components/text/9780062018465_Footnote_16'
 import TEXT9780062018465_FOOTNOTE_17 from '@/components/text/9780062018465_Footnote_17'
 import TEXT9780062018465_FOOTNOTE_18 from '@/components/text/9780062018465_Footnote_18'
 import TEXT9780062018465_FOOTNOTE_19 from '@/components/text/9780062018465_Footnote_19'
 import TEXT9780062018465_FOOTNOTE_20 from '@/components/text/9780062018465_Footnote_20'
 import TEXT9780062018465_FOOTNOTE_21 from '@/components/text/9780062018465_Footnote_21'
 import TEXT9780062018465_FOOTNOTE_22 from '@/components/text/9780062018465_Footnote_22'
 import TEXT9780062018465_FOOTNOTE_23 from '@/components/text/9780062018465_Footnote_23'
 import TEXT9780062018465_FOOTNOTE_24 from '@/components/text/9780062018465_Footnote_24'
 import TEXT9780062018465_FOOTNOTE_25 from '@/components/text/9780062018465_Footnote_25'
 import TEXT9780062018465_FOOTNOTE_26 from '@/components/text/9780062018465_Footnote_26'
 import TEXT9780062018465_FOOTNOTE_27 from '@/components/text/9780062018465_Footnote_27'
 import TEXT9780062018465_FOOTNOTE_28 from '@/components/text/9780062018465_Footnote_28'
 import TEXT9780062018465_FOOTNOTE_29 from '@/components/text/9780062018465_Footnote_29'
 import TEXT9780062018465_FOOTNOTE_30 from '@/components/text/9780062018465_Footnote_30'
 import TEXT9780062018465_FOOTNOTE_31 from '@/components/text/9780062018465_Footnote_31'
 import TEXT9780062018465_FOOTNOTE_32 from '@/components/text/9780062018465_Footnote_32'
 import TEXT9780062018465_FOOTNOTE_33 from '@/components/text/9780062018465_Footnote_33'
 import TEXT9780062018465_FOOTNOTE_34 from '@/components/text/9780062018465_Footnote_34'
 import TEXT9780062018465_FOOTNOTE_35 from '@/components/text/9780062018465_Footnote_35'
 import TEXT9780062018465_FOOTNOTE_36 from '@/components/text/9780062018465_Footnote_36'
 import TEXT9780062018465_FOOTNOTE_37 from '@/components/text/9780062018465_Footnote_37'
 import TEXT9780062018465_FOOTNOTE_38 from '@/components/text/9780062018465_Footnote_38'
 import TEXT9780062018465_FOOTNOTE_39 from '@/components/text/9780062018465_Footnote_39'
 import TEXT9780062018465_FOOTNOTE_40 from '@/components/text/9780062018465_Footnote_40'
 import TEXT9780062018465_FOOTNOTE_41 from '@/components/text/9780062018465_Footnote_41'
 import TEXT9780062018465_FOOTNOTE_42 from '@/components/text/9780062018465_Footnote_42'
 import TEXT9780062018465_FOOTNOTE_43 from '@/components/text/9780062018465_Footnote_43'
 import TEXT9780062018465_FOOTNOTE_44 from '@/components/text/9780062018465_Footnote_44'
 import TEXT9780062018465_FOOTNOTE_45 from '@/components/text/9780062018465_Footnote_45'
 import TEXT9780062018465_FOOTNOTE_46 from '@/components/text/9780062018465_Footnote_46'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062018465_Contents",
 			"name" : "text/9780062018465_Contents",
 			"component" : TEXT9780062018465_CONTENTS
 		},
 		{
 			"path" : "/text/9780062018465_Front_1",
 			"name" : "text/9780062018465_Front_1",
 			"component" : TEXT9780062018465_FRONT_1
 		},
 		{
 			"path" : "/text/9780062018465_Front_2",
 			"name" : "text/9780062018465_Front_2",
 			"component" : TEXT9780062018465_FRONT_2
 		},
 		{
 			"path" : "/text/9780062018465_Part_1",
 			"name" : "text/9780062018465_Part_1",
 			"component" : TEXT9780062018465_PART_1
 		},
 		{
 			"path" : "/text/9780062018465_Chapter_1",
 			"name" : "text/9780062018465_Chapter_1",
 			"component" : TEXT9780062018465_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780062018465_Chapter_2",
 			"name" : "text/9780062018465_Chapter_2",
 			"component" : TEXT9780062018465_CHAPTER_2
 		},
 		{
 			"path" : "/text/9780062018465_Part_2",
 			"name" : "text/9780062018465_Part_2",
 			"component" : TEXT9780062018465_PART_2
 		},
 		{
 			"path" : "/text/9780062018465_Chapter_3",
 			"name" : "text/9780062018465_Chapter_3",
 			"component" : TEXT9780062018465_CHAPTER_3
 		},
 		{
 			"path" : "/text/9780062018465_Chapter_4",
 			"name" : "text/9780062018465_Chapter_4",
 			"component" : TEXT9780062018465_CHAPTER_4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js